<div class="footer-inner">
  <!-- Zone 1: Brand (lockup + tagline + socials) -->
  <div class="footer-brand">
    <!-- Brand lockup: circular logo + name/sub column — mirrors header .brand treatment. -->
    <!-- aria-label gives the link a clean AT name; img alt provides its own accessible name. -->
    <a
      routerLink="/"
      class="footer-lockup groove-ring"
      aria-label="Russ Rodgers Bass Guitar Instruction — home"
    >
      <img
        class="footer-lockup-logo"
        src="/images/russlogo-112x112-black-bg.webp"
        alt="Russ Rodgers Bass Guitar Instruction"
        width="56"
        height="56"
        loading="lazy"
      />
      <span class="footer-lockup-text">
        <span class="footer-lockup-name">Russ Rodgers</span>
        <span class="footer-lockup-sub">Bass Guitar Instruction</span>
      </span>
    </a>

    <p class="footer-tagline">Private lessons, live over Zoom</p>

    <ul class="footer-socials" role="list" aria-label="Social media">
      @for (s of socialLinks; track s.key) {
        <li>
          <a
            class="footer-social groove-ring"
            [href]="s.href"
            [attr.aria-label]="s.label"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span
              class="footer-social-icon"
              [style.mask-image]="s.iconUrl"
              aria-hidden="true"
            ></span>
          </a>
        </li>
      }
    </ul>
  </div>

  <!-- Zone 2: Talk to Russ (contact). Its own column on desktop (3-up grid) so
       the brand zone isn't a tall lopsided stack; ordered BEFORE Explore in the
       DOM so mobile stacks brand → contact → Explore (phone/email near the top,
       no scroll to the page bottom). -->
  <div class="footer-col">
    <p class="footer-zone-heading">Talk to Russ</p>
    <address class="footer-contact">
      <a
        class="groove-text-link groove-ring footer-contact-link-shell"
        [href]="phoneHref"
        >{{ phoneDisplay }}</a
      >
      <a
        class="groove-text-link groove-ring footer-contact-link-shell"
        [href]="emailHref"
        >{{ emailDisplay }}</a
      >
    </address>
  </div>

  <!-- Zone 3: Explore (sitemap nav). siteLinks appends What I Teach and Zoom
       Setup after the NAV_GROUPS-derived list (spec §15.2, 2026-09-14,
       replacing the removed "For students" zone this footer used to carry
       as its own group) — spokes stay out of the top nav per spec §5, but a
       site map should still name them. -->
  <div class="footer-col">
    <p class="footer-zone-heading">Explore</p>
    <nav class="footer-nav" aria-label="Site map">
      @for (link of siteLinks; track link.url) {
        <a
          class="groove-text-link groove-ring footer-nav-link-shell"
          [routerLink]="link.url"
          routerLinkActive
          [routerLinkActiveOptions]="{ exact: link.url === '/' }"
          ariaCurrentWhenActive="page"
        >
          {{ link.name }}
        </a>
      }
    </nav>
  </div>
</div>

<div class="footer-legal">
  <p class="footer-copyright">
    © {{ copyrightYear }} Russell C. Rodgers — Russ Rodgers Bass Guitar
    Instruction — All Rights Reserved
  </p>
</div>
